class ProductStickyAddToCart {
  constructor() {
    this.productFormButtons = document.querySelector('.product-form__buttons');
    this.productStickyAddToCartEl = document.querySelector('[data-product-sticky-add-to-cart]');
    this.isIntersecting = false;
    
    if (this.productFormButtons) {
      this.initIntersectionObserver();
      initScrollListener();
      this.syncStickyQuantity();
    }
  }
  initScrollListener() {
  window.addEventListener('scroll', () => {
    const rect = this.productFormButtons.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    if (!isVisible) {
      this.productStickyAddToCartEl.classList.add('show');
    } else {
      this.productStickyAddToCartEl.classList.remove('show');
    }
  });
}


  syncStickyQuantity() {
    // Find the main quantity input and sticky hidden quantity input
    const mainQuantityInput = document.querySelector('.product-form__buttons input[name="quantity"]:not(.sticky-quantity-input)');
    const stickyQuantityInput = document.querySelector('.sticky-quantity-input');
    const stickyForm = this.productStickyAddToCartEl ? this.productStickyAddToCartEl.querySelector('form') : null;
    
    if (mainQuantityInput && stickyQuantityInput) {
      // Sync on change
      mainQuantityInput.addEventListener('change', () => {
        stickyQuantityInput.value = mainQuantityInput.value;
      });
      
      // Sync on input for real-time updates
      mainQuantityInput.addEventListener('input', () => {
        stickyQuantityInput.value = mainQuantityInput.value;
      });
      
      // Sync right before form submission (most important!)
      if (stickyForm) {
        stickyForm.addEventListener('submit', (e) => {
          stickyQuantityInput.value = mainQuantityInput.value;
        });
      }
      
      // Initial sync
      stickyQuantityInput.value = mainQuantityInput.value;
    }
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === this.productFormButtons) {
          this.isIntersecting = entry.isIntersecting;
          
          if (!entry.isIntersecting) {
            this.onElementOutOfView();
          } else {
            this.onElementInView();
          }
        }
      });
    }, options);

    this.observer.observe(this.productFormButtons);
  }

  onElementOutOfView() {    
    this.productStickyAddToCartEl.classList.add('show');
  }

  onElementInView() {
    this.productStickyAddToCartEl.classList.remove('show');
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductStickyAddToCart();
});